import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "phone_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 19.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.327 2.638C5 3.28 5 4.12 5 5.8v12.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C7.28 23 8.12 23 9.8 23h4.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 20.72 19 19.88 19 18.2V5.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 1 15.88 1 14.2 1H9.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311ZM15 3.002A1 1 0 0 1 14 4h-4a1 1 0 0 1-1-.998c-.43.003-.747.011-1.008.032a2.563 2.563 0 0 0-.367.05.603.603 0 0 0-.079.025 1 1 0 0 0-.437.437s-.003.005-.006.016a.603.603 0 0 0-.018.063 2.563 2.563 0 0 0-.05.367C7.001 4.392 7 4.927 7 5.8v12.4c0 .873.002 1.408.034 1.808.015.186.035.299.05.367a.597.597 0 0 0 .019.063l.006.016a1 1 0 0 0 .453.443c.01.004.03.01.063.018.068.016.181.036.367.05.4.033.935.035 1.808.035h4.4c.873 0 1.408-.002 1.808-.034.186-.015.299-.035.367-.05a.59.59 0 0 0 .079-.025 1 1 0 0 0 .437-.437s.003-.005.006-.016a.59.59 0 0 0 .018-.063c.016-.069.036-.181.05-.367.033-.4.035-.935.035-1.808V5.8c0-.873-.002-1.408-.034-1.808a2.576 2.576 0 0 0-.05-.367.597.597 0 0 0-.019-.063l-.006-.016a1 1 0 0 0-.437-.437s-.005-.003-.016-.006a.597.597 0 0 0-.063-.018 2.564 2.564 0 0 0-.367-.05c-.26-.022-.578-.03-1.008-.033Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }